<template>
    <steps :steps="steps"></steps>
</template>

<script>
import Steps from '@/Shared/Steps'

export default {
    components: {
        Steps
    },
    props: {
        currentStep: String,
        batchId: Number,
    },
    computed: {
        steps() {
            let stepList = [
                { id: '01', name: 'Map Data', href: route('attendee-import-map.edit', this.batchId), status: 'upcoming' },
                { id: '02', name: 'Validate', href: route('attendee-import-validate.edit', this.batchId), status: 'upcoming' },
                { id: '03', name: 'Deduplicate', href: route('attendee-import-deduplicate.edit', this.batchId), status: 'upcoming' },
                { id: '04', name: 'Review', href: route('attendee-import-review.edit', this.batchId), status: 'upcoming' },
            ]

            switch (this.currentStep) {
                case 'review':      stepList[3].status = 'current'; break;
                case 'deduplicate': stepList[2].status = 'current'; break;
                case 'validate':    stepList[1].status = 'current'; break;
                case 'map':         stepList[0].status = 'current'; break;
            }

            switch (this.currentStep) {
                case 'complete':    stepList[3].status = 'complete';
                case 'review':      stepList[2].status = 'complete';
                case 'deduplicate': stepList[1].status = 'complete';
                case 'validate':    stepList[0].status = 'complete';
            }

            return stepList;
        }
    }
}
</script>
